import React from 'react';
import {can} from './access';
import MasterReconciliation from './MasterReconciliation';
import MenuImportPreview from './MenuImportPreview';
import './ImportCenter.css';
export const importTypes=user=>[
 ...(can(user,'recipes.create_draft')?[['recipe','Recipes']]:[]),
 ...(can(user,'ingredients.create')?[['ingredient','Ingredients']]:[]),
 ...(user?.role==='Owner/Admin'?[['menu','Menu'],['reconciliation','Menu & Recipe reconciliation']]:[])
];
export default function ImportCenter({api,user,kind,brandId,onSelect,onChanged,onOpenBilling,onClose,SpreadsheetWorkflow}){
 const types=importTypes(user);
 const active=types.some(([id])=>id===kind)?kind:types[0]?.[0];
 return <section className="import-center" data-testid="import-center">
 <nav className="import-types" aria-label="Import type">{types.map(([id,label])=><button type="button" aria-current={active===id?'page':undefined} className={active===id?'active':''} key={id} onClick={()=>onSelect(id)}>{label}</button>)}</nav>
 {!types.length&&<p>Your permissions do not allow imports.</p>}
 {types.map(([id])=><div hidden={active!==id} key={id}>{id==='reconciliation'?<MasterReconciliation api={api} onCommitted={onChanged}/>:id==='menu'?<MenuImportPreview api={api} defaultBrandId={brandId} onClose={onClose} onCommitted={onChanged} onOpenBilling={onOpenBilling}/>:<SpreadsheetWorkflow api={api} user={user} importKind={id} onChanged={onChanged}/>}</div>)}
 </section>;
}
